// extracted by mini-css-extract-plugin
export default {"deletableItemsList":"DeletableItemsList_deletableItemsList__5Xvqh","deleteableItemsListItem":"DeletableItemsList_deleteableItemsListItem__Id8zT"};